import { defineMessages } from 'react-intl';

export const i18n: {
	errorAttachmentNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorNoFilename: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorPageNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorStillProcessing: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFailedToRetrieve: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorGeneric: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thumbnailAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spreadsheetIframeTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noticeBannerHeadline: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noticeBannerBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noticeBannerLinkLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorAttachmentNotFound: {
		id: 'viewxls-macro.error.attachment-not-found',
		defaultMessage: 'Attachment not found',
		description: 'Error shown when the specified attachment cannot be found',
	},
	errorNoFilename: {
		id: 'viewxls-macro.error.no-filename',
		defaultMessage: 'Attachment filename not found',
		description: 'Error shown when no attachment filename is specified in macro params',
	},
	errorPageNotFound: {
		id: 'viewxls-macro.error.page-not-found',
		defaultMessage: 'The viewfile macro is unable to locate the page.',
		description: 'Error shown when the page containing the attachment cannot be resolved',
	},
	errorStillProcessing: {
		id: 'viewxls-macro.error.still-processing',
		defaultMessage:
			'The attachment with name {filename} is still being processed, please refresh the page in a moment.',
		description: 'Error shown when the attachment is still being processed by the Media API',
	},
	errorFailedToRetrieve: {
		id: 'viewxls-macro.error.failed-to-retrieve',
		defaultMessage: 'Failed to retrieve attachment with name {filename}',
		description: 'Error shown when the attachment processing failed',
	},
	errorGeneric: {
		id: 'viewxls-macro.error.generic',
		defaultMessage: 'Something went wrong displaying this file.',
		description: 'Generic error fallback message',
	},
	thumbnailAlt: {
		id: 'viewxls-macro.thumbnail.alt',
		defaultMessage: 'Thumbnail preview for {filename}',
		description: 'Alt text for the thumbnail image shown in export/email mode',
	},
	spreadsheetIframeTitle: {
		id: 'viewxls-macro.spreadsheet.iframe-title',
		defaultMessage: 'Excel spreadsheet: {filename}',
		description: 'Accessible title for the iframe containing the spreadsheet preview',
	},
	noticeBannerHeadline: {
		id: 'viewxls-macro.notice.headline',
		defaultMessage: 'Excel: spreadsheet preview is finally here!',
		description: 'Headline in the upgrade notice card shown for Excel files',
	},
	noticeBannerBody: {
		id: 'viewxls-macro.notice.body',
		defaultMessage:
			'You can now display this file as a spreadsheet, instead of a PDF. Re-upload {filename} to display the new preview. You can access the file {link}.',
		description: 'Body text in the upgrade notice card shown for Excel files',
	},
	noticeBannerLinkLabel: {
		id: 'viewxls-macro.notice.link-label',
		defaultMessage: 'here',
		description: 'Link label in the upgrade notice card body text',
	},
});
